export default __webpack_public_path__ + "static/media/one_world_trade_center.bda1b3a3.jpg";